export default {
  inject: ['load'],
  data() {
    return {
      allChestPainPropagationsForOther: [],
      chestPainPropagation: null,
    };
  },
  methods: {
    getListOfChestPainPropagationsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllChestPainPropagations').then(() => {
        if (this.$store.state.chestPainPropagationModule.successFlag) {
          this.allChestPainPropagationsForOther =
            this.$store.state.chestPainPropagationModule.allChestPainPropagations;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chestPainPropagationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfChestPainPropagationsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getChestPainPropagationFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getChestPainPropagation', id).then(() => {
        if (this.$store.state.chestPainPropagationModule.successFlag) {
          this.chestPainPropagation =
            this.$store.state.chestPainPropagationModule.chestPainPropagation;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chestPainPropagationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getChestPainPropagationFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.chestPainPropagationModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
